import axios, { AxiosResponse } from 'axios';

import { getConfig } from '../config';
import { SingleYouTubeVideoList, PlaylistResponse } from '../database/videos';

const BASE_URL = getConfig().api.baseUrl;

/**
 * EventsApiContextType provides an API for interacting with Bandsintown Events.
 */
export type VideosApiContextType = {
    /**
     * getYouTubeVideos returns a 200 OK if the artist's YouTube videos are obtained from YouTube
     * or an error otherwise.
     * @returns An AxiosResponse with a list of YouTube videos.
     */
    getYouTubePlaylistByType: (mediaType: string, nextPageToken: string) => Promise<AxiosResponse<PlaylistResponse, any>>;

    getYouTubeVideoById: (
        id: string,
    ) => Promise<AxiosResponse<SingleYouTubeVideoList, any>>;
};

/**
 * getYouTubeVideos returns a 200 OK if the artist's YouTube videos are obtained from YouTube
 * or an error otherwise.
 * @returns An AxiosResponse with a list of YouTube videos.
 */
export function getYouTubePlaylistByType(mediaType: string, nextPageToken: string) {
    return axios.get<PlaylistResponse>(BASE_URL + '/public/videos/list', {
        params: { mediaType, nextPageToken },
    });
}

export function getYouTubeVideoById(id: string) {
    return axios.get<SingleYouTubeVideoList>(BASE_URL + '/public/videos/list', {
        params: { id },
    });
}
